import { render, staticRenderFns } from "./InfoBasico.vue?vue&type=template&id=7c8f7390&scoped=true&"
import script from "./InfoBasico.vue?vue&type=script&lang=js&"
export * from "./InfoBasico.vue?vue&type=script&lang=js&"
import style0 from "./InfoBasico.vue?vue&type=style&index=0&id=7c8f7390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f7390",
  null
  
)

export default component.exports